import tpl from './tpl';
import { appendHtml } from '../util/domHelper';
import './style.css';
var $loader = null;
export var loadStart = function loadStart(hint) {
  if (!$loader) {
    var template = tpl.replace('{hint}', hint);
    $loader = appendHtml(document.body, template, 'milo-loading-container', 'milo-loading-container');
  } else {
    $loader.style.display = 'block';
  }
};
export var loadStop = function loadStop() {
  if (!$loader) {
    return;
  }

  $loader.style.display = 'none';
};